import { useData } from 'components/common-form/hooks/useData';
import { TimeSpanField as TimeSpanFieldFromShare } from 'components/shared/TimeSpanField/TimeSpanField';
import { FC } from 'react';

import type { ProductNodeBuilderProps } from '../ProductNodeBuilder.model';

export const TimeSpanField: FC<ProductNodeBuilderProps> = ({ node: { id }, tabIndex }) => {
  const [timeSpan] = useData<string>(id);

  return <TimeSpanFieldFromShare id={id} key={id} value={timeSpan} e2e={id} tabIndex={tabIndex} />;
};
TimeSpanField.displayName = 'TimeSpanField';
